import { SvgIcon, SvgIconProps } from "@/domains/icons/svg-icon"

// TODO: Replace with actual HugeIcons SVG path for sword icon
// This is a placeholder - user will provide the correct path from HugeIcons
export const SwordIcon = ({ ...rest }: SvgIconProps) => {
  return (
    <SvgIcon {...rest}>
      {/* Placeholder path - needs to be replaced with HugeIcons sword path */}
      <path
        d="M6.5 2L2 6.5l4 4M21 3l-5 5M15 9l-4 4M9 15l-4 4M17 7l-4 4M19 5l-2 2M5 19l-2 2"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SvgIcon>
  )
}
